@if (isEditMode) {
  <div class="edit-mode">
    <form [formGroup]="editForm">
      <span class="label">{{ label }}</span>
      <div class="button-container">
        <button
          mat-flat-button
          color="primary"
          (click)="onSaveClicked()"
          [disabled]="!(editForm.valid && editForm.dirty)"
        >
          <mat-icon [ngClass]="showSmallIcons ? 'md-18' : ''">check</mat-icon>
          Save
        </button>
        <button
          type="button"
          mat-stroked-button
          (click)="toggleEditMode(false)"
        >
          <mat-icon [ngClass]="showSmallIcons ? 'md-18' : ''">close</mat-icon>
          Cancel
        </button>
      </div>
      <mat-form-field appearance="outline" class="value-description">
        <mat-select
          formControlName="description"
          placeholder="Select tenant timezone"
        >
          @for (timezone of lineupTimeZones; track timezone) {
            <mat-option [value]="timezone.name">
              {{ timezone.displayName }}
            </mat-option>
          }
        </mat-select>
        @if (editForm?.get('description').hasError('required')) {
          <mat-error> Timezone selection is required. </mat-error>
        }
      </mat-form-field>
    </form>
  </div>
} @else {
  <div class="read-mode">
    <span class="label">{{ label }}</span>
    <div class="value-description">
      @if (displayName) {
        <span>{{ displayName }}</span>
      }
    </div>
    @if (!readOnly) {
      <div class="button-container">
        <button
          mat-stroked-button
          (click)="toggleEditMode(true)"
          aria-label="Edit"
        >
          <mat-icon [ngClass]="showSmallIcons ? 'md-18' : ''">edit</mat-icon>
          Edit
        </button>
      </div>
    }
  </div>
}
